// @core/api/endpoints/webhook/retry_delivery.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  DeliveryResponse,
  RetryDeliveryRequest,
} from '../../../types/webhook';

const BASE_PATH = '/webhook';

/**
 * Retry failed delivery
 * Manually triggers a retry for a failed webhook delivery. The delivery is re-attempted immediately with the original payload.
 */
export async function RetryDelivery(
  endpoint_id: string,
  delivery_id: string,
  data: RetryDeliveryRequest,
  options?: RequestOptions
): Promise<DeliveryResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/endpoints/:endpoint_id/deliveries/:delivery_id/retry`;
  requestPath = requestPath.replace(':endpoint_id', encodeURIComponent(endpoint_id));
  requestPath = requestPath.replace(':delivery_id', encodeURIComponent(delivery_id));
  const requestOptions = options;
  return client.post<DeliveryResponse>(requestPath, data, requestOptions);
}
